import React from 'react';
import { H3, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import AlienAbduction from 'assets/alien-abduction.svg';
import styled, { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';
import { Spacing } from 'styleguide/spacing';
import { t } from 'translations/t';

const Container = styled(View)`
  flex: 1;
  justify-content: center;
`;

export const WorkoutNotFoundScreen = () => {
  return (
    <ThemeProvider theme={themeState.current}>
      <Container>
        <View
          style={{
            height: 400,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <AlienAbduction />
          <H3
            style={{
              textAlign: 'center',
              marginTop: Spacing.md,
              marginBottom: Spacing.md,
            }}
          >
            {t('web.workoutDetails.workoutNotFound')}
          </H3>
          <P2 style={{ textAlign: 'center', maxWidth: 300 }}>
            {t('web.workoutDetails.workoutNotFound.desc')}
          </P2>
        </View>
      </Container>
    </ThemeProvider>
  );
};
